import React from 'react';

import classes from './sticky-header.module.scss';
import { useStickyHeaderElements } from './use-sticky-header-elements';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const setCSSVariable = (property: string, value: string) => {
  const root = document.querySelector<HTMLElement>(':root');
  root?.style.setProperty(property, value);
};

/**
 * The sticky header always scrolls out if the page scrolls down.
 * If the page scrolls up, the header scrolls in and is displayed until the page scrolls down.
 *
 * For this functionality we listen to the scroll event to figure out if the page scrolls
 * down or up (`lastScrollTop` vs. `currentScrollTop`).
 *
 * When the page scrolls up, the height of the header container is set to the current scrollTop.
 * So the sticky header scrolls in.
 *
 * When the page scrolls down, the height of the header container is set to the current scrollTop plus the headerHeight.
 * So the sticky header now scrolls out.
 */
export const StickyHeader: React.FC<Props> = ({
  children,
  className = '',
  ...rest
}) => {
  useStickyHeaderElements('var(--header-height)');

  return (
    <header className={`${classes.header} ${className}`} {...rest}>
      {children}
    </header>
  );
};

export default StickyHeader;
